import React, {useState} from 'react'
import {Button} from 'react-bootstrap'
import {kickPlayer} from '../../functions/firebase'

export default function Name({back, player, isadmin, gameId, names}) {
    const [ state, setState] = useState({clicked:false})
    const clicked = ()=> {
        setState({clicked: true})
        setTimeout(() => {
        setState({clicked: false})
            
        }, 5000);
    }
  
  
    return (
        <> 
{isadmin? 
    
    <div className={`name `+ back} onClick={clicked} >
     
        <img src={player.avatar} alt=""/>
        {state.clicked?  
        <>
        <Button variant="danger" onClick={()=> kickPlayer(player.id, gameId, names)}  style={{width:'100%', padding:"10px 0"}}>Kick</Button>

        </> 
        : ''}
<h6>{player.name.substring(0,9)}</h6>
   
    </div>
    : 
        <div className={`name `+ back}  >
        <img src={player.avatar} alt=""/>
<h6>{player.name.substring(0,9)}</h6>
   
    </div>
}
     

    </ >
    )
}
